require("@rails/ujs").start()
require("@rails/activestorage").start()
require('channels');
require('leaflet')
require('moment');
require('@shopify/draggable')

// Rails activestorage direct upload
import '../src/direct-upload';

import 'cleave.js'
import 'cleave.js/dist/addons/cleave-phone.jp';

// import "leaflet/dist/leaflet";

// for nested model form
import 'cocoon';

// for searching name in select tag
import '../src/select2';
import '../src/parent_company_fields';


// Datepicker
import '../src/flatpickr';

// Formatter for form:input
import '../src/postcode';

import '../src/sites';
import '../src/price_slider';

import '../src/cost_management';

// 工事台帳集計出力機能
import '../src/export_construction_ledger';

// 契約に紐づくファイル類のアップロード機能
import '../src/estimation_files_upload';

// 契約に紐づくファイル類のアップロード機能
import '../src/pre_construction_files_upload';

// 契約に紐づく発注依頼書のアップロード機能
import '../src/purchase_request_files_upload';

// 契約に紐づく注文書のアップロード機能
import '../src/order_files_upload';

// loading spinner
import '../src/loading';

import '../src/home';

// workflow
import '../src/workflow';
import '../src/sp_workflow_approver';

// workflow condition builder
import '../src/condition_builder';

// workflow approver search
import '../src/approver_search';



// 制御文字除去
import '../src/control_chars';

// Custom validation messages
import '../src/custom_validation';

// 外部サイト同期モーダル
import '../src/worker_external_site_sync_modal';

// 作業員更新確認モーダル
import '../src/worker_update_confirmation_modal';

// 個別作業員スクレイピング進捗ポーリング
import '../src/worker_scrape_polling';
// 個別作業員ビルディ取得進捗ポーリング（グリーンサイトとは独立）
import '../src/worker_buildee_scrape_polling';

// 月次締め処理ポーリング
import '../src/monthly_closing_polling';

// 認証後レイアウト共通UI
import '../src/authenticated_layout';

// 点検明細単位の写真・コメント登録モーダル（新UI: ファイル名 + 削除ボタン）。
// document 委譲で1回だけバインドするためインライン JS とは統合せず、このモジュールに一本化する。
import '../src/inspection_attachment';

// 会社区分と協力会社ランクの表示制御
import '../src/company_rank_form';

// 累計実績管理βの部門dropdown幅調整
import '../src/site_costs_beta_business_unit_dropdown';

// 任意軸集計の会社参照元フィールド表示制御
import '../src/aggregation_summaries/company_reference_type_fields';

// 契約終了/現場終了モーダルの超過理由コメント必須制御
import '../src/finish_excess_reason_modal';
